import React, { FunctionComponent, useEffect } from "react"
import { Controller, FormProvider, useForm } from "react-hook-form"
import { newsTags } from "../../api/Definitions"
import FormInput from "../../components/Form/Inputs/FormInput"
import SelectInput from "../../components/Form/Select/Select"
import { iChangeType } from "../../definitions/interfaces"
import { iNewsQuery } from "../../definitions/News"

interface iProps {
  setQuery: (data: iNewsQuery, resetQuery?: boolean) => void
  query: iNewsQuery
}

const NewsFilters: FunctionComponent<iProps> = ({ setQuery, query }) => {
  const onChange = ({ name, value }: iChangeType) => {
    setQuery({ [name]: value })
  }

  useEffect(() => {
    methods.reset(query)
  }, [query])

  const methods = useForm<iNewsQuery>({ defaultValues: query })

  return (
    <div className="filters">
      <div className="filters-form">
        <FormProvider {...methods}>
          <FormInput
            onChange={onChange}
            autoComplete="off"
            placeholder="Search by title..."
            name="title"
          />

          <Controller
            render={({ value, onChange: handleChange }) => (
              <SelectInput
                name="tag"
                options={newsTags}
                label="Tags"
                isClearable
                isMulti
                value={value}
                onChange={(value) => {
                  onChange({ name: "tag", value })
                  handleChange(value)
                }}
              />
            )}
            control={methods.control}
            name="tag"
          />
        </FormProvider>
      </div>
    </div>
  )
}

export default NewsFilters
